import { Fragment, useMemo, useSyncExternalStore } from 'react'
import { Platform, View } from 'react-native'
import { usePathname } from 'expo-router'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import {
  getImpersonationSession,
  subscribeImpersonationSession,
} from '../../src/zportiAdmin/helpers/impersonationToken.helper'
import { LandingMarketingImpersonationBanner } from './LandingMarketingImpersonationBanner'

/** Approximate strip height (padding + row) so layout clears under the fixed bar. */
const MARKETING_IMPERSONATION_STRIP_BODY_PX = 50

/**
 * Web: show the impersonation exit strip on every route outside `/app/*` (e.g. `/`, `/privacy`)
 * so operators are not limited to the homepage. Reserves in-flow space so content is not covered.
 */
export function MarketingSiteImpersonationChrome() {
  const pathname = usePathname() ?? ''
  const insets = useSafeAreaInsets()
  const session = useSyncExternalStore(
    subscribeImpersonationSession,
    getImpersonationSession,
    getImpersonationSession,
  )

  const fixedHostStyle = useMemo(
    () => ({
      position: 'fixed' as never,
      top: 0,
      left: 0,
      right: 0,
      zIndex: 10000,
      paddingTop: insets.top,
    }),
    [insets.top],
  )

  const spacerHeight = insets.top + MARKETING_IMPERSONATION_STRIP_BODY_PX

  if (Platform.OS !== 'web') return null
  if (pathname.startsWith('/app')) return null
  if (!session?.token) return null

  return (
    <Fragment>
      <View style={{ height: spacerHeight }} />
      <View style={fixedHostStyle} pointerEvents="box-none">
        <LandingMarketingImpersonationBanner />
      </View>
    </Fragment>
  )
}
